<app-enfaf-modal (onClose)="confirmCloseModal()" [svgIcon]="'message-square-dark'"
    [title]="data.parentId ? 'Responder comentario' : 'Añadir comentario'" (onConfirm)="saveComment()"
    [disableConfirmButton]="form.invalid || isSaving" [buttonConfirmText]="'Enviar comentario'" [isLoading]="isSaving"
    [isComments]="true">
    <form [formGroup]="form" autocomplete="off" class="comment-form">
        <mat-form-field color="primary" appearance="outline" class="comment-form__field">
            <textarea matInput placeholder="Escribe tus comentarios y sugerencias para el alumno..."
                formControlName="content" autocomplete="off" rows="5" class="comment-form__textarea"></textarea>
        </mat-form-field>
    </form>
</app-enfaf-modal>